import script from "./EspoProvenance.vue?vue&type=script&setup=true&lang=js"
export * from "./EspoProvenance.vue?vue&type=script&setup=true&lang=js"

import "./EspoProvenance.vue?vue&type=style&index=0&id=43d5df9c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-43d5df9c"]])

export default __exports__